import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import Home from "./pages/Home";
import Category from "./pages/Category";
import ProductDetail from "./pages/ProductDetail";
import CategoriesPage from "./pages/CategoriesPage";
import Shop from "./pages/Shop";
import About from "./pages/About";
import Store from "./pages/Store";
import Contact from "./pages/Contact";
import SSS from "./pages/SSS";
import OrderTracking from "./pages/OrderTracking";
import OrdersHistory from "./pages/OrdersHistory";
import InfoPage from "./pages/InfoPage";
import BlogList from "./pages/BlogList";
import BlogPost from "./pages/BlogPost";
import NotFound from "./pages/NotFound";
import ScrollToTop from "./components/ScrollToTop";
import AnnouncementBanner from "./components/AnnouncementBanner";
import CartLayout from "./pages/cart/CartLayout";
import CartItemsStep from "./pages/cart/CartItemsStep";
import CartDeliveryStep from "./pages/cart/CartDeliveryStep";
import CartReviewStep from "./pages/cart/CartReviewStep";
import CartSuccessStep from "./pages/cart/CartSuccessStep";
import CartPaymentStep from "./pages/cart/CartPaymentStep";
import { PaymentSuccessPage, PaymentFailurePage } from "./pages/PaymentResult";
import { CartProvider } from "./lib/CartContext";
import { ProductsProvider } from "./lib/ProductsContext";
import { ZeoContentProvider } from "./lib/ZeoContentContext";
import { CustomerAuthProvider } from "./lib/CustomerAuthContext";
import { BlogsProvider } from "./lib/BlogsContext";

function AppShell() {
  return (
    <>
      <AnnouncementBanner />
      <Toaster
        position="top-center"
        toastOptions={{
          style: {
            borderRadius: "16px",
            border: "1px solid #EAEAEA",
            fontFamily: "'Outfit', sans-serif",
          },
        }}
      />

      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/kategoriler" element={<CategoriesPage />} />
          <Route path="/kategori/:categoryId" element={<Category />} />
          <Route path="/urunler" element={<Shop />} />
          <Route path="/urun/:productId" element={<ProductDetail />} />
          <Route path="/hakkimizda" element={<About />} />
          <Route path="/magazamiz" element={<Store />} />
          <Route path="/bize-ulasin" element={<Contact />} />
          <Route path="/sss" element={<SSS />} />
          <Route path="/siparis-takibi" element={<OrderTracking />} />
          <Route path="/hesabim/siparislerim" element={<OrdersHistory />} />
          <Route path="/bilgi/:slug" element={<InfoPage />} />
          <Route path="/blog" element={<BlogList />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
          <Route path="/sepet" element={<CartLayout />}>
            <Route index element={<CartItemsStep />} />
            <Route path="teslimat" element={<CartDeliveryStep />} />
            <Route path="onayla" element={<CartReviewStep />} />
            <Route path="odeme" element={<CartPaymentStep />} />
            <Route path="tesekkurler" element={<CartSuccessStep />} />
          </Route>
          <Route path="/siparis/odeme-basarili" element={<PaymentSuccessPage />} />
          <Route path="/siparis/odeme-basarisiz" element={<PaymentFailurePage />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    </>
  );
}

function App() {
  return (
    <div className="App">
      <ZeoContentProvider>
        <ProductsProvider>
          <BlogsProvider>
            <CustomerAuthProvider>
              <CartProvider>
                <AppShell />
              </CartProvider>
            </CustomerAuthProvider>
          </BlogsProvider>
        </ProductsProvider>
      </ZeoContentProvider>
    </div>
  );
}

export default App;
